import { render, staticRenderFns } from "./TriangleIcon.vue?vue&type=template&id=374865e6&scoped=true"
import script from "./TriangleIcon.vue?vue&type=script&lang=ts"
export * from "./TriangleIcon.vue?vue&type=script&lang=ts"
import style0 from "./TriangleIcon.vue?vue&type=style&index=0&id=374865e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374865e6",
  null
  
)

export default component.exports